<template>
  <v-app
    id="forgot_password"
    class="brand_neutral"
  >
    <v-content>
      <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
            lg4
          >
            <v-flex
              class="mb-5"
            >
              <v-img
                style="margin: 0 auto;"
                width="200px"
                src="/img/logo_light_no_top.png"
              />
            </v-flex>
            <v-card class="elevation-1 pa-3">
              <v-card-title class="text-xs-center">
                <h1 class="flex my-4 primary--text">
                  {{ $t('Commerce Console') }}
                </h1>

                <div class="absolute-right flag-login-position">
                  <language-switcher
                    flag-only
                    flag-size="24px"/>
                </div>
              </v-card-title>

              <v-card-text>
                <v-form>
                  <v-text-field
                    :error-count="errors.length"
                    :error-messages="errors"
                    v-model="email"
                    append-icon="person"
                    name="email"
                    label="Email"
                    type="text"
                  />
                </v-form>
              </v-card-text>
              <v-card-actions>
                <router-link
                  :to="{
                    name: 'Login',
                  }"
                  class="pl-2"
                >
                  {{ $t('Remember password? Log In!') }}
                </router-link>
                <v-spacer/>
                <v-btn
                  :loading="loading"
                  color="primary"
                  @click="sendLink"
                >
                  {{ $t('Send Reset Link') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import LanguageSwitcher from '../components/LanguageSwitcher'
import { mapGetters } from 'vuex'
import http from '../services/api/client'
import store from '../store'
import radio from '../plugins/bus'

export default {
  components: {
    LanguageSwitcher
  },

  data () {
    return {
      email: '',
      errors: [],
      client: http(store, radio)
    }
  },

  computed: {
    ...mapGetters({
      loading: 'pagination/loading'
    })
  },

  watch: {
    email: function (val) {
      if (val) {
        this.errors = []
      }
    }
  },

  methods: {
    sendLink () {
      if (!this.email) {
        this.errors = [this.$t('Email is required')]
        return
      }

      this.client.request({
        url: 'auth/v1/users/password/reset',
        method: 'POST',
        data: {
          email: this.email,
          redirect_url: this.getRedirectUrl()
        },
        headers: {
          'x-user-type': 'admin'
        }
      }).then(() => {
        this.errors = []
        this.$toast(this.$t('Password reset link has been sent to your email if there is an account associated with it.'))
        this.$router.replace({ name: 'Login' })
      }).catch(e => {
        if (e.response.status === 422) {
          this.errors = e.response.data.errors.email
        }

        this.$toast.error(this.$t(e.response.data.message))
      })
    },

    getRedirectUrl () {
      let url = window.location.origin

      if (this.$router.options.base) {
        url = url + this.$router.options.base
      }

      return url + 'password-reset'
    }
  }
}
</script>

<style scoped lang="css">
#forgot_password {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}

a {
  text-decoration: none;
}
</style>
